export default __webpack_public_path__ + "static/media/deco-img(4).d13ff274.png";